import _toConsumableArray from "/codebuild/output/src2324380805/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/codebuild/output/src2324380805/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/codebuild/output/src2324380805/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src2324380805/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import _regeneratorRuntime from "/codebuild/output/src2324380805/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
import e, { createContext as t, useState as o, useCallback as l, useMemo as r, useContext as n, useRef as c, useEffect as i, useLayoutEffect as s, useImperativeHandle as a } from "react";
import { arrow as u, computePosition as d, offset as p, flip as v, shift as m, autoUpdate as f } from "@floating-ui/dom";
import y from "classnames";
var h = "react-tooltip-core-styles",
  w = "react-tooltip-base-styles",
  b = {
    core: !1,
    base: !1
  };
function S(_ref) {
  var e = _ref.css,
    _ref$id = _ref.id,
    t = _ref$id === void 0 ? w : _ref$id,
    _ref$type = _ref.type,
    o = _ref$type === void 0 ? "base" : _ref$type,
    l = _ref.ref;
  var r, n;
  if (!e || "undefined" == typeof document || b[o]) return;
  if ("core" === o && "undefined" != typeof process && (null === (r = null === process || void 0 === process ? void 0 : process.env) || void 0 === r ? void 0 : r.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
  if ("base" !== o && "undefined" != typeof process && (null === (n = null === process || void 0 === process ? void 0 : process.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  "core" === o && (t = h), l || (l = {});
  var _l = l,
    c = _l.insertAt;
  if (document.getElementById(t)) return void console.warn("[react-tooltip] Element with id '".concat(t, "' already exists. Call `removeStyle()` first"));
  var i = document.head || document.getElementsByTagName("head")[0],
    s = document.createElement("style");
  s.id = t, s.type = "text/css", "top" === c && i.firstChild ? i.insertBefore(s, i.firstChild) : i.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), b[o] = !0;
}
function E() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$type = _ref2.type,
    e = _ref2$type === void 0 ? "base" : _ref2$type,
    _ref2$id = _ref2.id,
    t = _ref2$id === void 0 ? w : _ref2$id;
  if (!b[e]) return;
  "core" === e && (t = h);
  var o = document.getElementById(t);
  "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn("[react-tooltip] Failed to remove 'style' element with id '".concat(t, "'. Call `injectStyle()` first")), b[e] = !1;
}
var g = function g(e, t, o) {
    var l = null;
    return function () {
      var _this = this;
      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }
      var n = function n() {
        l = null, o || e.apply(_this, r);
      };
      o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
  },
  _ = "DEFAULT_TOOLTIP_ID",
  A = {
    anchorRefs: new Set(),
    activeAnchor: {
      current: null
    },
    attach: function attach() {},
    detach: function detach() {},
    setActiveAnchor: function setActiveAnchor() {}
  },
  O = t({
    getTooltipData: function getTooltipData() {
      return A;
    }
  }),
  T = function T(_ref3) {
    var t = _ref3.children;
    var _o = o(_defineProperty({}, _, new Set())),
      _o2 = _slicedToArray(_o, 2),
      n = _o2[0],
      c = _o2[1],
      _o3 = o(_defineProperty({}, _, {
        current: null
      })),
      _o4 = _slicedToArray(_o3, 2),
      i = _o4[0],
      s = _o4[1],
      a = function a(e) {
        for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          t[_key2 - 1] = arguments[_key2];
        }
        c(function (o) {
          var l;
          var r = null !== (l = o[e]) && void 0 !== l ? l : new Set();
          return t.forEach(function (e) {
            return r.add(e);
          }), _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, e, new Set(r)));
        });
      },
      u = function u(e) {
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        c(function (o) {
          var l = o[e];
          return l ? (t.forEach(function (e) {
            return l.delete(e);
          }), _objectSpread({}, o)) : o;
        });
      },
      d = l(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
        var t, o;
        return {
          anchorRefs: null !== (t = n[e]) && void 0 !== t ? t : new Set(),
          activeAnchor: null !== (o = i[e]) && void 0 !== o ? o : {
            current: null
          },
          attach: function attach() {
            for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t[_key4] = arguments[_key4];
            }
            return a.apply(void 0, [e].concat(t));
          },
          detach: function detach() {
            for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              t[_key5] = arguments[_key5];
            }
            return u.apply(void 0, [e].concat(t));
          },
          setActiveAnchor: function setActiveAnchor(t) {
            return function (e, t) {
              s(function (o) {
                var l;
                return (null === (l = o[e]) || void 0 === l ? void 0 : l.current) === t.current ? o : _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, e, t));
              });
            }(e, t);
          }
        };
      }, [n, i, a, u]),
      p = r(function () {
        return {
          getTooltipData: d
        };
      }, [d]);
    return e.createElement(O.Provider, {
      value: p
    }, t);
  };
function k() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
  return n(O).getTooltipData(e);
}
var L = function L(_ref4) {
    var t = _ref4.tooltipId,
      o = _ref4.children,
      l = _ref4.className,
      r = _ref4.place,
      n = _ref4.content,
      s = _ref4.html,
      a = _ref4.variant,
      u = _ref4.offset,
      d = _ref4.wrapper,
      p = _ref4.events,
      v = _ref4.positionStrategy,
      m = _ref4.delayShow,
      f = _ref4.delayHide;
    var _k = k(t),
      h = _k.attach,
      w = _k.detach,
      b = c(null);
    return i(function () {
      return h(b), function () {
        w(b);
      };
    }, []), e.createElement("span", {
      ref: b,
      className: y("react-tooltip-wrapper", l),
      "data-tooltip-place": r,
      "data-tooltip-content": n,
      "data-tooltip-html": s,
      "data-tooltip-variant": a,
      "data-tooltip-offset": u,
      "data-tooltip-wrapper": d,
      "data-tooltip-events": p,
      "data-tooltip-position-strategy": v,
      "data-tooltip-delay-show": m,
      "data-tooltip-delay-hide": f
    }, o);
  },
  C = "undefined" != typeof window ? s : i,
  R = function R(e) {
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    var t = getComputedStyle(e);
    return ["overflow", "overflow-x", "overflow-y"].some(function (e) {
      var o = t.getPropertyValue(e);
      return "auto" === o || "scroll" === o;
    });
  },
  x = function x(e) {
    if (!e) return null;
    var t = e.parentElement;
    for (; t;) {
      if (R(t)) return t;
      t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  },
  N = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
      var _ref5$elementReferenc, e, _ref5$tooltipReferenc, t, _ref5$tooltipArrowRef, o, _ref5$place, l, _ref5$offset, r, _ref5$strategy, n, _ref5$middlewares, c, i, s;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref5$elementReferenc = _ref5.elementReference, e = _ref5$elementReferenc === void 0 ? null : _ref5$elementReferenc, _ref5$tooltipReferenc = _ref5.tooltipReference, t = _ref5$tooltipReferenc === void 0 ? null : _ref5$tooltipReferenc, _ref5$tooltipArrowRef = _ref5.tooltipArrowReference, o = _ref5$tooltipArrowRef === void 0 ? null : _ref5$tooltipArrowRef, _ref5$place = _ref5.place, l = _ref5$place === void 0 ? "top" : _ref5$place, _ref5$offset = _ref5.offset, r = _ref5$offset === void 0 ? 10 : _ref5$offset, _ref5$strategy = _ref5.strategy, n = _ref5$strategy === void 0 ? "absolute" : _ref5$strategy, _ref5$middlewares = _ref5.middlewares, c = _ref5$middlewares === void 0 ? [p(Number(r)), v({
              fallbackAxisSideDirection: "start"
            }), m({
              padding: 5
            })] : _ref5$middlewares, i = _ref5.border;
            if (e) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", {
              tooltipStyles: {},
              tooltipArrowStyles: {},
              place: l
            });
          case 3:
            if (!(null === t)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", {
              tooltipStyles: {},
              tooltipArrowStyles: {},
              place: l
            });
          case 5:
            s = c;
            return _context.abrupt("return", o ? (s.push(u({
              element: o,
              padding: 5
            })), d(e, t, {
              placement: l,
              strategy: n,
              middleware: s
            }).then(function (_ref7) {
              var e = _ref7.x,
                t = _ref7.y,
                o = _ref7.placement,
                l = _ref7.middlewareData;
              var r, n;
              var c = {
                  left: "".concat(e, "px"),
                  top: "".concat(t, "px"),
                  border: i
                },
                _ref8 = null !== (r = l.arrow) && void 0 !== r ? r : {
                  x: 0,
                  y: 0
                },
                s = _ref8.x,
                a = _ref8.y,
                u = null !== (n = {
                  top: "bottom",
                  right: "left",
                  bottom: "top",
                  left: "right"
                }[o.split("-")[0]]) && void 0 !== n ? n : "bottom",
                d = i && {
                  borderBottom: i,
                  borderRight: i
                };
              var p = 0;
              if (i) {
                var _e2 = "".concat(i).match(/(\d+)px/);
                p = (null == _e2 ? void 0 : _e2[1]) ? Number(_e2[1]) : 1;
              }
              return {
                tooltipStyles: c,
                tooltipArrowStyles: _objectSpread(_objectSpread({
                  left: null != s ? "".concat(s, "px") : "",
                  top: null != a ? "".concat(a, "px") : "",
                  right: "",
                  bottom: ""
                }, d), {}, _defineProperty({}, u, "-".concat(4 + p, "px"))),
                place: o
              };
            })) : d(e, t, {
              placement: "bottom",
              strategy: n,
              middleware: s
            }).then(function (_ref9) {
              var e = _ref9.x,
                t = _ref9.y,
                o = _ref9.placement;
              return {
                tooltipStyles: {
                  left: "".concat(e, "px"),
                  top: "".concat(t, "px")
                },
                tooltipArrowStyles: {},
                place: o
              };
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function N(_x) {
      return _ref6.apply(this, arguments);
    };
  }();
var $ = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
  },
  j = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
  };
var I = function I(_ref10) {
    var t = _ref10.forwardRef,
      r = _ref10.id,
      n = _ref10.className,
      s = _ref10.classNameArrow,
      _ref10$variant = _ref10.variant,
      u = _ref10$variant === void 0 ? "dark" : _ref10$variant,
      d = _ref10.anchorId,
      p = _ref10.anchorSelect,
      _ref10$place = _ref10.place,
      v = _ref10$place === void 0 ? "top" : _ref10$place,
      _ref10$offset = _ref10.offset,
      m = _ref10$offset === void 0 ? 10 : _ref10$offset,
      _ref10$events = _ref10.events,
      h = _ref10$events === void 0 ? ["hover"] : _ref10$events,
      _ref10$openOnClick = _ref10.openOnClick,
      w = _ref10$openOnClick === void 0 ? !1 : _ref10$openOnClick,
      _ref10$positionStrate = _ref10.positionStrategy,
      b = _ref10$positionStrate === void 0 ? "absolute" : _ref10$positionStrate,
      S = _ref10.middlewares,
      E = _ref10.wrapper,
      _ref10$delayShow = _ref10.delayShow,
      _ = _ref10$delayShow === void 0 ? 0 : _ref10$delayShow,
      _ref10$delayHide = _ref10.delayHide,
      A = _ref10$delayHide === void 0 ? 0 : _ref10$delayHide,
      _ref10$float = _ref10.float,
      O = _ref10$float === void 0 ? !1 : _ref10$float,
      _ref10$hidden = _ref10.hidden,
      T = _ref10$hidden === void 0 ? !1 : _ref10$hidden,
      _ref10$noArrow = _ref10.noArrow,
      L = _ref10$noArrow === void 0 ? !1 : _ref10$noArrow,
      _ref10$clickable = _ref10.clickable,
      R = _ref10$clickable === void 0 ? !1 : _ref10$clickable,
      _ref10$closeOnEsc = _ref10.closeOnEsc,
      I = _ref10$closeOnEsc === void 0 ? !1 : _ref10$closeOnEsc,
      _ref10$closeOnScroll = _ref10.closeOnScroll,
      B = _ref10$closeOnScroll === void 0 ? !1 : _ref10$closeOnScroll,
      _ref10$closeOnResize = _ref10.closeOnResize,
      z = _ref10$closeOnResize === void 0 ? !1 : _ref10$closeOnResize,
      D = _ref10.openEvents,
      q = _ref10.closeEvents,
      H = _ref10.globalCloseEvents,
      M = _ref10.imperativeModeOnly,
      W = _ref10.style,
      P = _ref10.position,
      F = _ref10.afterShow,
      K = _ref10.afterHide,
      U = _ref10.content,
      V = _ref10.contentWrapperRef,
      X = _ref10.isOpen,
      Y = _ref10.setIsOpen,
      G = _ref10.activeAnchor,
      Z = _ref10.setActiveAnchor,
      J = _ref10.border,
      Q = _ref10.opacity,
      ee = _ref10.arrowColor,
      _ref10$role = _ref10.role,
      te = _ref10$role === void 0 ? "tooltip" : _ref10$role;
    var oe;
    var le = c(null),
      re = c(null),
      ne = c(null),
      ce = c(null),
      ie = c(null),
      _o7 = o(v),
      _o8 = _slicedToArray(_o7, 2),
      se = _o8[0],
      ae = _o8[1],
      _o9 = o({}),
      _o10 = _slicedToArray(_o9, 2),
      ue = _o10[0],
      de = _o10[1],
      _o11 = o({}),
      _o12 = _slicedToArray(_o11, 2),
      pe = _o12[0],
      ve = _o12[1],
      _o13 = o(!1),
      _o14 = _slicedToArray(_o13, 2),
      me = _o14[0],
      fe = _o14[1],
      _o15 = o(!1),
      _o16 = _slicedToArray(_o15, 2),
      ye = _o16[0],
      he = _o16[1],
      _o17 = o(null),
      _o18 = _slicedToArray(_o17, 2),
      we = _o18[0],
      be = _o18[1],
      Se = c(!1),
      Ee = c(null),
      _k2 = k(r),
      ge = _k2.anchorRefs,
      _e = _k2.setActiveAnchor,
      Ae = c(!1),
      _o19 = o([]),
      _o20 = _slicedToArray(_o19, 2),
      Oe = _o20[0],
      Te = _o20[1],
      ke = c(!1),
      Le = w || h.includes("click"),
      Ce = Le || (null == D ? void 0 : D.click) || (null == D ? void 0 : D.dblclick) || (null == D ? void 0 : D.mousedown),
      Re = D ? _objectSpread({}, D) : {
        mouseenter: !0,
        focus: !0,
        click: !1,
        dblclick: !1,
        mousedown: !1
      };
    !D && Le && Object.assign(Re, {
      mouseenter: !1,
      focus: !1,
      click: !0
    });
    var xe = q ? _objectSpread({}, q) : {
      mouseleave: !0,
      blur: !0,
      click: !1,
      dblclick: !1,
      mouseup: !1
    };
    !q && Le && Object.assign(xe, {
      mouseleave: !1,
      blur: !1
    });
    var Ne = H ? _objectSpread({}, H) : {
      escape: I || !1,
      scroll: B || !1,
      resize: z || !1,
      clickOutsideAnchor: Ce || !1
    };
    M && (Object.assign(Re, {
      mouseenter: !1,
      focus: !1,
      click: !1,
      dblclick: !1,
      mousedown: !1
    }), Object.assign(xe, {
      mouseleave: !1,
      blur: !1,
      click: !1,
      dblclick: !1,
      mouseup: !1
    }), Object.assign(Ne, {
      escape: !1,
      scroll: !1,
      resize: !1,
      clickOutsideAnchor: !1
    })), C(function () {
      return ke.current = !0, function () {
        ke.current = !1;
      };
    }, []);
    var $e = function $e(e) {
      ke.current && (e && he(!0), setTimeout(function () {
        ke.current && (null == Y || Y(e), void 0 === X && fe(e));
      }, 10));
    };
    i(function () {
      if (void 0 === X) return function () {
        return null;
      };
      X && he(!0);
      var e = setTimeout(function () {
        fe(X);
      }, 10);
      return function () {
        clearTimeout(e);
      };
    }, [X]), i(function () {
      if (me !== Se.current) if (ie.current && clearTimeout(ie.current), Se.current = me, me) null == F || F();else {
        var _e3 = function (e) {
          var t = e.match(/^([\d.]+)(m?s?)$/);
          if (!t) return 0;
          var _t = _slicedToArray(t, 3),
            o = _t[1],
            l = _t[2];
          return "s" !== l && "ms" !== l ? 0 : Number(o) * ("ms" === l ? 1 : 1e3);
        }(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        ie.current = setTimeout(function () {
          he(!1), be(null), null == K || K();
        }, _e3 + 25);
      }
    }, [me]);
    var je = function je() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
        ne.current && clearTimeout(ne.current), ne.current = setTimeout(function () {
          $e(!0);
        }, e);
      },
      Ie = function Ie() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : A;
        ce.current && clearTimeout(ce.current), ce.current = setTimeout(function () {
          Ae.current || $e(!1);
        }, e);
      },
      Be = function Be(e) {
        var t;
        if (!e) return;
        var o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return Z(null), void _e({
          current: null
        });
        _ ? je() : $e(!0), Z(o), _e({
          current: o
        }), ce.current && clearTimeout(ce.current);
      },
      ze = function ze() {
        R ? Ie(A || 100) : A ? Ie() : $e(!1), ne.current && clearTimeout(ne.current);
      },
      De = function De(_ref11) {
        var e = _ref11.x,
          t = _ref11.y;
        var o;
        var l = {
          getBoundingClientRect: function getBoundingClientRect() {
            return {
              x: e,
              y: t,
              width: 0,
              height: 0,
              top: t,
              left: e,
              right: e,
              bottom: t
            };
          }
        };
        N({
          place: null !== (o = null == we ? void 0 : we.place) && void 0 !== o ? o : v,
          offset: m,
          elementReference: l,
          tooltipReference: le.current,
          tooltipArrowReference: re.current,
          strategy: b,
          middlewares: S,
          border: J
        }).then(function (e) {
          Object.keys(e.tooltipStyles).length && de(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && ve(e.tooltipArrowStyles), ae(e.place);
        });
      },
      qe = function qe(e) {
        if (!e) return;
        var t = e,
          o = {
            x: t.clientX,
            y: t.clientY
          };
        De(o), Ee.current = o;
      },
      He = function He(e) {
        var t;
        if (!me) return;
        var o = e.target;
        if (null === (t = le.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [document.querySelector("[id='".concat(d, "']"))].concat(_toConsumableArray(Oe)).some(function (e) {
          return null == e ? void 0 : e.contains(o);
        }) || ($e(!1), ne.current && clearTimeout(ne.current));
      },
      Me = g(Be, 50, !0),
      We = g(ze, 50, !0),
      Pe = l(function () {
        var e, t;
        var o = null !== (e = null == we ? void 0 : we.position) && void 0 !== e ? e : P;
        o ? De(o) : O ? Ee.current && De(Ee.current) : (null == G ? void 0 : G.isConnected) && N({
          place: null !== (t = null == we ? void 0 : we.place) && void 0 !== t ? t : v,
          offset: m,
          elementReference: G,
          tooltipReference: le.current,
          tooltipArrowReference: re.current,
          strategy: b,
          middlewares: S,
          border: J
        }).then(function (e) {
          ke.current && (Object.keys(e.tooltipStyles).length && de(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && ve(e.tooltipArrowStyles), ae(e.place));
        });
      }, [me, G, U, W, v, null == we ? void 0 : we.place, m, b, P, null == we ? void 0 : we.position, O]);
    i(function () {
      var e, t;
      var o = new Set(ge);
      Oe.forEach(function (e) {
        o.add({
          current: e
        });
      });
      var l = document.querySelector("[id='".concat(d, "']"));
      l && o.add({
        current: l
      });
      var r = function r() {
          $e(!1);
        },
        n = x(G),
        c = x(le.current);
      Ne.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == c || c.addEventListener("scroll", r));
      var i = null;
      Ne.resize ? window.addEventListener("resize", r) : G && le.current && (i = f(G, le.current, Pe, {
        ancestorResize: !0,
        elementResize: !0,
        layoutShift: !0
      }));
      var s = function s(e) {
        "Escape" === e.key && $e(!1);
      };
      Ne.escape && window.addEventListener("keydown", s), Ne.clickOutsideAnchor && window.addEventListener("click", He);
      var a = [],
        u = function u(e) {
          me && (null == e ? void 0 : e.target) === G || Be(e);
        },
        p = function p(e) {
          me && (null == e ? void 0 : e.target) === G && ze();
        },
        v = ["mouseenter", "mouseleave", "focus", "blur"],
        m = ["click", "dblclick", "mousedown", "mouseup"];
      Object.entries(Re).forEach(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
          e = _ref13[0],
          t = _ref13[1];
        t && (v.includes(e) ? a.push({
          event: e,
          listener: Me
        }) : m.includes(e) && a.push({
          event: e,
          listener: u
        }));
      }), Object.entries(xe).forEach(function (_ref14) {
        var _ref15 = _slicedToArray(_ref14, 2),
          e = _ref15[0],
          t = _ref15[1];
        t && (v.includes(e) ? a.push({
          event: e,
          listener: We
        }) : m.includes(e) && a.push({
          event: e,
          listener: p
        }));
      }), O && a.push({
        event: "mousemove",
        listener: qe
      });
      var y = function y() {
          Ae.current = !0;
        },
        h = function h() {
          Ae.current = !1, ze();
        };
      return R && !Ce && (null === (e = le.current) || void 0 === e || e.addEventListener("mouseenter", y), null === (t = le.current) || void 0 === t || t.addEventListener("mouseleave", h)), a.forEach(function (_ref16) {
        var e = _ref16.event,
          t = _ref16.listener;
        o.forEach(function (o) {
          var l;
          null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
        });
      }), function () {
        var e, t;
        Ne.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == c || c.removeEventListener("scroll", r)), Ne.resize ? window.removeEventListener("resize", r) : null == i || i(), Ne.clickOutsideAnchor && window.removeEventListener("click", He), Ne.escape && window.removeEventListener("keydown", s), R && !Ce && (null === (e = le.current) || void 0 === e || e.removeEventListener("mouseenter", y), null === (t = le.current) || void 0 === t || t.removeEventListener("mouseleave", h)), a.forEach(function (_ref17) {
          var e = _ref17.event,
            t = _ref17.listener;
          o.forEach(function (o) {
            var l;
            null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
          });
        });
      };
    }, [G, Pe, ye, ge, Oe, D, q, H, Le]), i(function () {
      var e, t;
      var o = null !== (t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
      !o && r && (o = "[data-tooltip-id='".concat(r, "']"));
      var l = new MutationObserver(function (e) {
        var t = [],
          l = [];
        e.forEach(function (e) {
          if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) {
            e.target.getAttribute("data-tooltip-id") === r && t.push(e.target);
          }
          if ("childList" === e.type) {
            if (G) {
              var _t2 = _toConsumableArray(e.removedNodes).filter(function (e) {
                return 1 === e.nodeType;
              });
              if (o) try {
                l.push.apply(l, _toConsumableArray(_t2.filter(function (e) {
                  return e.matches(o);
                }))), l.push.apply(l, _toConsumableArray(_t2.flatMap(function (e) {
                  return _toConsumableArray(e.querySelectorAll(o));
                })));
              } catch (e) {}
              _t2.some(function (e) {
                var t;
                return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, G)) && (he(!1), $e(!1), Z(null), ne.current && clearTimeout(ne.current), ce.current && clearTimeout(ce.current), !0);
              });
            }
            if (o) try {
              var _l2 = _toConsumableArray(e.addedNodes).filter(function (e) {
                return 1 === e.nodeType;
              });
              t.push.apply(t, _toConsumableArray(_l2.filter(function (e) {
                return e.matches(o);
              }))), t.push.apply(t, _toConsumableArray(_l2.flatMap(function (e) {
                return _toConsumableArray(e.querySelectorAll(o));
              })));
            } catch (e) {}
          }
        }), (t.length || l.length) && Te(function (e) {
          return [].concat(_toConsumableArray(e.filter(function (e) {
            return !l.includes(e);
          })), t);
        });
      });
      return l.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-tooltip-id"]
      }), function () {
        l.disconnect();
      };
    }, [r, p, null == we ? void 0 : we.anchorSelect, G]), i(function () {
      Pe();
    }, [Pe]), i(function () {
      if (!(null == V ? void 0 : V.current)) return function () {
        return null;
      };
      var e = new ResizeObserver(function () {
        setTimeout(function () {
          return Pe();
        });
      });
      return e.observe(V.current), function () {
        e.disconnect();
      };
    }, [U, null == V ? void 0 : V.current]), i(function () {
      var e;
      var t = document.querySelector("[id='".concat(d, "']")),
        o = [].concat(_toConsumableArray(Oe), [t]);
      G && o.includes(G) || Z(null !== (e = Oe[0]) && void 0 !== e ? e : t);
    }, [d, Oe, G]), i(function () {
      return function () {
        ne.current && clearTimeout(ne.current), ce.current && clearTimeout(ce.current);
      };
    }, []), i(function () {
      var e;
      var t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p;
      if (!t && r && (t = "[data-tooltip-id='".concat(r, "']")), t) try {
        var _e4 = Array.from(document.querySelectorAll(t));
        Te(_e4);
      } catch (e) {
        Te([]);
      }
    }, [r, p, null == we ? void 0 : we.anchorSelect]);
    var Fe = null !== (oe = null == we ? void 0 : we.content) && void 0 !== oe ? oe : U,
      Ke = me && Object.keys(ue).length > 0;
    return a(t, function () {
      return {
        open: function open(e) {
          if (null == e ? void 0 : e.anchorSelect) try {
            document.querySelector(e.anchorSelect);
          } catch (t) {
            return void console.warn("[react-tooltip] \"".concat(e.anchorSelect, "\" is not a valid CSS selector"));
          }
          be(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : $e(!0);
        },
        close: function close(e) {
          (null == e ? void 0 : e.delay) ? Ie(e.delay) : $e(!1);
        },
        activeAnchor: G,
        place: se,
        isOpen: Boolean(ye && !T && Fe && Ke)
      };
    }), ye && !T && Fe ? e.createElement(E, {
      id: r,
      role: te,
      className: y("react-tooltip", $.tooltip, j.tooltip, j[u], n, "react-tooltip__place-".concat(se), $[Ke ? "show" : "closing"], Ke ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $.fixed, R && $.clickable),
      onTransitionEnd: function onTransitionEnd(e) {
        ie.current && clearTimeout(ie.current), me || "opacity" !== e.propertyName || (he(!1), be(null), null == K || K());
      },
      style: _objectSpread(_objectSpread(_objectSpread({}, W), ue), {}, {
        opacity: void 0 !== Q && Ke ? Q : void 0
      }),
      ref: le
    }, Fe, e.createElement(E, {
      className: y("react-tooltip-arrow", $.arrow, j.arrow, s, L && $.noArrow),
      style: _objectSpread(_objectSpread({}, pe), {}, {
        background: ee ? "linear-gradient(to right bottom, transparent 50%, ".concat(ee, " 50%)") : void 0
      }),
      ref: re
    })) : null;
  },
  B = function B(_ref18) {
    var t = _ref18.content;
    return e.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  },
  z = function z(e, t) {
    return !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t);
  },
  D = e.forwardRef(function (_ref19, G) {
    var t = _ref19.id,
      l = _ref19.anchorId,
      r = _ref19.anchorSelect,
      n = _ref19.content,
      s = _ref19.html,
      a = _ref19.render,
      u = _ref19.className,
      d = _ref19.classNameArrow,
      _ref19$variant = _ref19.variant,
      p = _ref19$variant === void 0 ? "dark" : _ref19$variant,
      _ref19$place = _ref19.place,
      v = _ref19$place === void 0 ? "top" : _ref19$place,
      _ref19$offset = _ref19.offset,
      m = _ref19$offset === void 0 ? 10 : _ref19$offset,
      _ref19$wrapper = _ref19.wrapper,
      f = _ref19$wrapper === void 0 ? "div" : _ref19$wrapper,
      _ref19$children = _ref19.children,
      h = _ref19$children === void 0 ? null : _ref19$children,
      _ref19$events = _ref19.events,
      w = _ref19$events === void 0 ? ["hover"] : _ref19$events,
      _ref19$openOnClick = _ref19.openOnClick,
      b = _ref19$openOnClick === void 0 ? !1 : _ref19$openOnClick,
      _ref19$positionStrate = _ref19.positionStrategy,
      S = _ref19$positionStrate === void 0 ? "absolute" : _ref19$positionStrate,
      E = _ref19.middlewares,
      _ref19$delayShow = _ref19.delayShow,
      g = _ref19$delayShow === void 0 ? 0 : _ref19$delayShow,
      _ref19$delayHide = _ref19.delayHide,
      _ = _ref19$delayHide === void 0 ? 0 : _ref19$delayHide,
      _ref19$float = _ref19.float,
      A = _ref19$float === void 0 ? !1 : _ref19$float,
      _ref19$hidden = _ref19.hidden,
      O = _ref19$hidden === void 0 ? !1 : _ref19$hidden,
      _ref19$noArrow = _ref19.noArrow,
      T = _ref19$noArrow === void 0 ? !1 : _ref19$noArrow,
      _ref19$clickable = _ref19.clickable,
      L = _ref19$clickable === void 0 ? !1 : _ref19$clickable,
      _ref19$closeOnEsc = _ref19.closeOnEsc,
      C = _ref19$closeOnEsc === void 0 ? !1 : _ref19$closeOnEsc,
      _ref19$closeOnScroll = _ref19.closeOnScroll,
      R = _ref19$closeOnScroll === void 0 ? !1 : _ref19$closeOnScroll,
      _ref19$closeOnResize = _ref19.closeOnResize,
      x = _ref19$closeOnResize === void 0 ? !1 : _ref19$closeOnResize,
      N = _ref19.openEvents,
      $ = _ref19.closeEvents,
      j = _ref19.globalCloseEvents,
      _ref19$imperativeMode = _ref19.imperativeModeOnly,
      D = _ref19$imperativeMode === void 0 ? !1 : _ref19$imperativeMode,
      q = _ref19.style,
      H = _ref19.position,
      M = _ref19.isOpen,
      _ref19$disableStyleIn = _ref19.disableStyleInjection,
      W = _ref19$disableStyleIn === void 0 ? !1 : _ref19$disableStyleIn,
      P = _ref19.border,
      F = _ref19.opacity,
      K = _ref19.arrowColor,
      U = _ref19.setIsOpen,
      V = _ref19.afterShow,
      X = _ref19.afterHide,
      _ref19$role = _ref19.role,
      Y = _ref19$role === void 0 ? "tooltip" : _ref19$role;
    var _o21 = o(n),
      _o22 = _slicedToArray(_o21, 2),
      Z = _o22[0],
      J = _o22[1],
      _o23 = o(s),
      _o24 = _slicedToArray(_o23, 2),
      Q = _o24[0],
      ee = _o24[1],
      _o25 = o(v),
      _o26 = _slicedToArray(_o25, 2),
      te = _o26[0],
      oe = _o26[1],
      _o27 = o(p),
      _o28 = _slicedToArray(_o27, 2),
      le = _o28[0],
      re = _o28[1],
      _o29 = o(m),
      _o30 = _slicedToArray(_o29, 2),
      ne = _o30[0],
      ce = _o30[1],
      _o31 = o(g),
      _o32 = _slicedToArray(_o31, 2),
      ie = _o32[0],
      se = _o32[1],
      _o33 = o(_),
      _o34 = _slicedToArray(_o33, 2),
      ae = _o34[0],
      ue = _o34[1],
      _o35 = o(A),
      _o36 = _slicedToArray(_o35, 2),
      de = _o36[0],
      pe = _o36[1],
      _o37 = o(O),
      _o38 = _slicedToArray(_o37, 2),
      ve = _o38[0],
      me = _o38[1],
      _o39 = o(f),
      _o40 = _slicedToArray(_o39, 2),
      fe = _o40[0],
      ye = _o40[1],
      _o41 = o(w),
      _o42 = _slicedToArray(_o41, 2),
      he = _o42[0],
      we = _o42[1],
      _o43 = o(S),
      _o44 = _slicedToArray(_o43, 2),
      be = _o44[0],
      Se = _o44[1],
      _o45 = o(null),
      _o46 = _slicedToArray(_o45, 2),
      Ee = _o46[0],
      ge = _o46[1],
      _o47 = o(null),
      _o48 = _slicedToArray(_o47, 2),
      _e = _o48[0],
      Ae = _o48[1],
      Oe = c(W),
      _k3 = k(t),
      Te = _k3.anchorRefs,
      ke = _k3.activeAnchor,
      Le = function Le(e) {
        return null == e ? void 0 : e.getAttributeNames().reduce(function (t, o) {
          var l;
          if (o.startsWith("data-tooltip-")) {
            t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
          }
          return t;
        }, {});
      },
      Ce = function Ce(e) {
        var t = {
          place: function place(e) {
            var t;
            oe(null !== (t = e) && void 0 !== t ? t : v);
          },
          content: function content(e) {
            J(null != e ? e : n);
          },
          html: function html(e) {
            ee(null != e ? e : s);
          },
          variant: function variant(e) {
            var t;
            re(null !== (t = e) && void 0 !== t ? t : p);
          },
          offset: function offset(e) {
            ce(null === e ? m : Number(e));
          },
          wrapper: function wrapper(e) {
            var t;
            ye(null !== (t = e) && void 0 !== t ? t : f);
          },
          events: function events(e) {
            var t = null == e ? void 0 : e.split(" ");
            we(null != t ? t : w);
          },
          "position-strategy": function positionStrategy(e) {
            var t;
            Se(null !== (t = e) && void 0 !== t ? t : S);
          },
          "delay-show": function delayShow(e) {
            se(null === e ? g : Number(e));
          },
          "delay-hide": function delayHide(e) {
            ue(null === e ? _ : Number(e));
          },
          float: function float(e) {
            pe(null === e ? A : "true" === e);
          },
          hidden: function hidden(e) {
            me(null === e ? O : "true" === e);
          },
          "class-name": function className(e) {
            ge(e);
          }
        };
        Object.values(t).forEach(function (e) {
          return e(null);
        }), Object.entries(e).forEach(function (_ref20) {
          var _ref21 = _slicedToArray(_ref20, 2),
            e = _ref21[0],
            o = _ref21[1];
          var l;
          null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
      };
    i(function () {
      J(n);
    }, [n]), i(function () {
      ee(s);
    }, [s]), i(function () {
      oe(v);
    }, [v]), i(function () {
      re(p);
    }, [p]), i(function () {
      ce(m);
    }, [m]), i(function () {
      se(g);
    }, [g]), i(function () {
      ue(_);
    }, [_]), i(function () {
      pe(A);
    }, [A]), i(function () {
      me(O);
    }, [O]), i(function () {
      Se(S);
    }, [S]), i(function () {
      Oe.current !== W && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [W]), i(function () {
      "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
        detail: {
          disableCore: "core" === W,
          disableBase: W
        }
      }));
    }, []), i(function () {
      var e;
      var o = new Set(Te);
      var n = r;
      if (!n && t && (n = "[data-tooltip-id='".concat(t, "']")), n) try {
        document.querySelectorAll(n).forEach(function (e) {
          o.add({
            current: e
          });
        });
      } catch (e) {
        console.warn("[react-tooltip] \"".concat(n, "\" is not a valid CSS selector"));
      }
      var c = document.querySelector("[id='".concat(l, "']"));
      if (c && o.add({
        current: c
      }), !o.size) return function () {
        return null;
      };
      var i = null !== (e = null != _e ? _e : c) && void 0 !== e ? e : ke.current,
        s = new MutationObserver(function (e) {
          e.forEach(function (e) {
            var t;
            if (!i || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
            var o = Le(i);
            Ce(o);
          });
        }),
        a = {
          attributes: !0,
          childList: !1,
          subtree: !1
        };
      if (i) {
        var _e5 = Le(i);
        Ce(_e5), s.observe(i, a);
      }
      return function () {
        s.disconnect();
      };
    }, [Te, ke, _e, l, r]), i(function () {
      (null == q ? void 0 : q.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), P && !z("border", "".concat(P)) && console.warn("[react-tooltip] \"".concat(P, "\" is not a valid `border`.")), (null == q ? void 0 : q.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !z("opacity", "".concat(F)) && console.warn("[react-tooltip] \"".concat(F, "\" is not a valid `opacity`."));
    }, []);
    var Re = h;
    var xe = c(null);
    if (a) {
      var _t3 = a({
        content: null != Z ? Z : null,
        activeAnchor: _e
      });
      Re = _t3 ? e.createElement("div", {
        ref: xe,
        className: "react-tooltip-content-wrapper"
      }, _t3) : null;
    } else Z && (Re = Z);
    Q && (Re = e.createElement(B, {
      content: Q
    }));
    var Ne = {
      forwardRef: G,
      id: t,
      anchorId: l,
      anchorSelect: r,
      className: y(u, Ee),
      classNameArrow: d,
      content: Re,
      contentWrapperRef: xe,
      place: te,
      variant: le,
      offset: ne,
      wrapper: fe,
      events: he,
      openOnClick: b,
      positionStrategy: be,
      middlewares: E,
      delayShow: ie,
      delayHide: ae,
      float: de,
      hidden: ve,
      noArrow: T,
      clickable: L,
      closeOnEsc: C,
      closeOnScroll: R,
      closeOnResize: x,
      openEvents: N,
      closeEvents: $,
      globalCloseEvents: j,
      imperativeModeOnly: D,
      style: q,
      position: H,
      isOpen: M,
      border: P,
      opacity: F,
      arrowColor: K,
      setIsOpen: U,
      afterShow: V,
      afterHide: X,
      activeAnchor: _e,
      setActiveAnchor: function setActiveAnchor(e) {
        return Ae(e);
      },
      role: Y
    };
    return e.createElement(I, _objectSpread({}, Ne));
  });
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", function (e) {
  e.detail.disableCore || S({
    css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}",
    type: "core"
  }), e.detail.disableBase || S({
    css: "\n.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}",
    type: "base"
  });
});
export { D as Tooltip, T as TooltipProvider, L as TooltipWrapper, E as removeStyle };